import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
.pet-policy{
  display: flex;
  flex-direction: column;
  margin-bottom: ${toRem(0)};
  color: ${theme.color['black']};
  .section-heading{
    display: flex;
    margin-top: ${toRem(-5)};
    padding: 0;
    .pet-policy-icon{
      &:before{
        margin-right: ${toRem(18)};
        position: relative;
      }
    }
    .temp-icon{
      height: ${toRem(20)};
      padding-right: ${toRem(18)};
    }
    .pet-policy-heading{
    }
  }
  .pet-policy-information{
    margin-top: ${toRem(16)};
    padding-left: ${toRem(48)};
  }
  .pet-policy-sub-info{
    padding-left: ${toRem(48)};
    margin-top: ${toRem(8)};
  }
}
@media only ${theme.mediaQuery.smallerTablet} {
  .pet-policy{
    display: flex;
    flex-direction: column;
    margin-bottom: ${toRem(4)};
    .section-heading{
      display: flex;
      margin-top: ${toRem(-5)};
      .pet-policy-icon{
        &:before{
          margin-right: ${toRem(18)};
        }
      }
      .temp-icon{
        height: ${toRem(20)};
        padding-right: ${toRem(18)};
      }
      .pet-policy-heading{
      }
    }
    .pet-policy-information{
      margin-top: ${toRem(16)};
      padding-left: ${toRem(41)};

    }
    .pet-policy-sub-info{
      padding-left: ${toRem(41)};
      margin-top: ${toRem(8)};
    }
  }
}

@media only ${theme.mediaQuery.allMobiles} {
  .pet-policy{
    display: flex;
    flex-direction: column;
    margin-bottom: ${toRem(15)};
    .section-heading{
      display: flex;
      margin-top: ${toRem(-5)};
      .pet-policy-icon{
        &:before{
          margin-right: ${toRem(13)};
        }
      }
      .temp-icon{
        height: ${toRem(16)};
        padding-right: ${toRem(13)};
      }
      .pet-policy-heading{
      }
    }
    .pet-policy-information{
      margin-top: ${toRem(15)};
      padding-left: ${toRem(34)};

    }
    .pet-policy-sub-info{
      padding-left: ${toRem(34)};
      margin-top: ${toRem(12)};
    }
  }
}
.hqv-modal {
  &.pet-policy{
    display: flex;
    flex-direction: column;
    margin-bottom: ${toRem(4)};
    padding-left:5px;
    .section-heading{
      display: flex;
      margin-top: ${toRem(-5)};
      .pet-policy-icon{
        &:before{
          margin-right: ${toRem(18)};
        }
      }
      .temp-icon{
        height: ${toRem(20)};
        padding-right: ${toRem(18)};
      }
      .pet-policy-heading{
      }
    }
    .pet-policy-information{
      margin-top: ${toRem(16)};
      padding-left: ${toRem(48)};

    }
    .pet-policy-sub-info{
      padding-left: ${toRem(48)};
      margin-top: ${toRem(8)};
    }
  }
}`}
`;
